import useSWR from 'swr';
import api, { buildSaveRequestConfig } from '../../config/configApi';

const getToken = () => localStorage.getItem('token'); // ajuste a chave se for outra

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.origens ?? [];
  } catch (err) {
    console.error('Erro ao buscar origens:', err?.response?.status, err?.message);
    return [];
  }
};

export default function useOrigensConfiguracoes() {
  const {
    data: origens = [], error, isLoading, mutate,
  } = useSWR(
    '/origem/config/origens',
    fetcher,
  );

  const criarOrigem = async (payload) => {
    try {
      const token = getToken();
      await api.post('/origem/config/origens', payload, buildSaveRequestConfig({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }));
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para criar origem.');
      }
      throw err;
    }
  };

  const editarOrigem = async (id, payload) => {
    try {
      await api.put(`/origem/config/origens/${id}`, payload);
      await mutate();
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        throw new Error('Sem permissão para editar origem.');
      }
      throw err;
    }
  };

  return {
    origens,
    isLoading,
    isError: !!error,
    criarOrigem,
    editarOrigem,
    refetch: mutate,
  };
}
